module.exports = __webpack_public_path__ + "diveBar_marquee.e955cb6.png";